import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tabs" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
    key: 0,
    class: "chart-container"
};
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 2,
    class: "breakdown-section"
};
const _hoisted_6 = { class: "breakdown-header" };
const _hoisted_7 = {
    key: 0,
    class: "tax-code"
};
const _hoisted_8 = { class: "breakdown-grid" };
const _hoisted_9 = { class: "breakdown-row" };
const _hoisted_10 = { class: "value-group" };
const _hoisted_11 = { class: "value" };
const _hoisted_12 = {
    key: 0,
    class: "ytd-panel"
};
const _hoisted_13 = { class: "ytd-value" };
const _hoisted_14 = { class: "breakdown-row" };
const _hoisted_15 = { class: "value-group" };
const _hoisted_16 = { class: "value" };
const _hoisted_17 = {
    key: 0,
    class: "deductions-sublist"
};
const _hoisted_18 = { class: "breakdown-row" };
const _hoisted_19 = { class: "value-group" };
const _hoisted_20 = { class: "value" };
const _hoisted_21 = {
    key: 0,
    class: "ytd-panel"
};
const _hoisted_22 = { class: "ytd-value" };
const _hoisted_23 = { class: "breakdown-row" };
const _hoisted_24 = { class: "value-group" };
const _hoisted_25 = { class: "value" };
const _hoisted_26 = {
    key: 0,
    class: "ytd-panel"
};
const _hoisted_27 = { class: "ytd-value" };
const _hoisted_28 = { class: "breakdown-row" };
const _hoisted_29 = { class: "value-group" };
const _hoisted_30 = { class: "value" };
const _hoisted_31 = {
    key: 0,
    class: "ytd-panel"
};
const _hoisted_32 = { class: "ytd-value" };
const _hoisted_33 = {
    key: 0,
    class: "breakdown-row"
};
const _hoisted_34 = { class: "value-group" };
const _hoisted_35 = { class: "value" };
const _hoisted_36 = {
    key: 0,
    class: "ytd-panel"
};
const _hoisted_37 = { class: "ytd-value" };
const _hoisted_38 = {
    key: 1,
    class: "breakdown-row"
};
const _hoisted_39 = { class: "value-group" };
const _hoisted_40 = { class: "value" };
const _hoisted_41 = {
    key: 0,
    class: "ytd-panel"
};
const _hoisted_42 = { class: "ytd-value" };
const _hoisted_43 = { class: "breakdown-row" };
const _hoisted_44 = { class: "breakdown-item net-pay" };
const _hoisted_45 = { class: "value" };
const _hoisted_46 = {
    key: 3,
    class: "view-payslip-wrap"
};
const _hoisted_47 = { class: "tax-year-title" };
const _hoisted_48 = { class: "tax-form-list" };
import { ref, computed, onMounted, getCurrentInstance, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useDocuments } from '@/composables/useDocuments';
import { useWhatsApp } from '@/composables/useWhatsApp';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import AiChatBanner from './elements/AiChatBanner.vue';
import WhatsAppPromoCard from './elements/WhatsAppPromoCard.vue';
import WhatsAppEnableDrawer from './elements/WhatsAppEnableDrawer.vue';
import DocumentListItem from './elements/DocumentListItem.vue';
import { useDarkMode } from '@/composables/useDarkMode';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PayslipsPage',
    setup(__props) {
        const { isDarkMode } = useDarkMode();
        use([CanvasRenderer, BarChart, GridComponent]);
        const chartRef = ref(null);
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getDocuments } = useDocuments();
        const instance = getCurrentInstance();
        const whatsAppNumber = instance?.appContext.config.globalProperties.$whatsAppNumber || '';
        const whatsAppPromoCard = ref(null);
        const whatsAppEnableDrawer = ref(null);
        const { handleWhatsAppAction, handleEnableWhatsApp, handleWhatsAppEnableDone, handleWhatsAppDrawerClosed } = useWhatsApp({
            whatsAppPromoCard,
            whatsAppEnableDrawer,
            whatsAppNumber,
        });
        const aiContext = computed(() => {
            var _a;
            const parts = [];
            if (activeTab.value === 'tax') {
                const allKinds = ['P60', 'P11D', 'P45'];
                const present = new Set(hmrcForms.value.map(f => f.kind));
                const missing = allKinds.filter(k => !present.has(k));
                if (hmrcForms.value.length === 0) {
                    parts.push('user has NO tax forms on file (no P60, no P11D, no P45)');
                }
                else {
                    const byKind = {};
                    for (const f of hmrcForms.value) {
                        (byKind[_a = f.kind] || (byKind[_a] = [])).push(f.year);
                    }
                    const summary = Object.entries(byKind)
                        .map(([k, years]) => `${k} (${[...new Set(years)].sort().join(', ')})`)
                        .join('; ');
                    parts.push(`tax forms on file: ${summary}`);
                    if (missing.length > 0) {
                        parts.push(`user does NOT have any ${missing.join(' or ')} on file — do not suggest questions about ${missing.join(' or ')}`);
                    }
                }
            }
            else {
                if (selectedPayslip.value) {
                    const p = selectedPayslip.value;
                    parts.push(`latest payslip — tax code ${p.taxCode || 'unknown'}, gross £${Math.round(p.grossPay)}, tax £${Math.round(p.tax)}, NI £${Math.round(p.ni)}, net £${Math.round(p.netPay)}`);
                }
                else if (payslips.value.length === 0) {
                    parts.push('user has not uploaded any payslips yet');
                }
            }
            return parts.join('. ');
        });
        const aiPrompts = computed(() => activeTab.value === 'tax'
            ? [
                'What is a P60?',
                'How do I read my P60?',
                'When should I get a P45?',
                'Explain P11D benefits',
            ]
            : [
                'Tell me about my tax code',
                'Why has my tax code changed?',
                'How much tax will I pay this year?',
                'Explain my deductions',
            ]);
        const payslips = ref([]);
        const hmrcForms = ref([]);
        const activeTab = ref('pay');
        const tabs = [
            { key: 'pay', label: 'Pay' },
            { key: 'tax', label: 'Tax forms' },
        ];
        const tabRefs = ref([]);
        const tabActiveLeft = ref(4);
        const tabActiveWidth = ref(0);
        function setTabRef(index, el) {
            tabRefs.value[index] = el;
        }
        function updateTabActivePosition() {
            const activeIndex = tabs.findIndex(t => t.key === activeTab.value);
            const el = tabRefs.value[activeIndex];
            if (el) {
                tabActiveLeft.value = el.offsetLeft;
                tabActiveWidth.value = el.offsetWidth;
            }
        }
        watch(activeTab, () => {
            nextTick(updateTabActivePosition);
        });
        const chartData = ref(null);
        const selectedPayslip = ref(null);
        const selectedIndex = ref(-1);
        const expandedRows = ref({});
        function toggleRow(key) {
            expandedRows.value[key] = !expandedRows.value[key];
        }
        const deductionsTotal = computed(() => {
            const p = selectedPayslip.value;
            if (!p)
                return 0;
            return (p.salarySacrifice || 0) + (p.ni || 0) + (p.tax || 0) + (p.employerNi || 0) + (p.employerPension || 0);
        });
        // Base/hover colour per stacked series; the selected month uses the brighter hover colour.
        const COLOUR_PAIRS = [
            ['#6ee7b7', '#34d399'], // Net Pay
            ['#fca5a5', '#f87171'], // Tax
            ['#93c5fd', '#60a5fa'], // Salary Sacrifice
            ['#fcd34d', '#fbbf24'], // National Insurance
        ];
        const chartOption = computed(() => {
            if (!chartData.value)
                return null;
            const tickColour = isDarkMode.value ? 'rgba(232, 228, 223, 0.7)' : '#64748b';
            const splitColour = isDarkMode.value ? 'rgba(232, 228, 223, 0.1)' : '#e2e8f0';
            const sel = selectedIndex.value;
            const series = [chartData.value.net, chartData.value.tax, chartData.value.salarySacrifice, chartData.value.ni];
            return {
                animationDuration: 750,
                animationEasing: 'quarticInOut',
                grid: { left: 0, right: 0, top: 8, bottom: 0, containLabel: true },
                xAxis: {
                    type: 'category',
                    data: chartData.value.labels,
                    axisTick: { show: false },
                    axisLine: { show: false },
                    axisLabel: { color: tickColour, fontSize: 13, fontWeight: 500 },
                },
                yAxis: {
                    type: 'value',
                    splitNumber: 4,
                    axisLine: { show: false },
                    axisTick: { show: false },
                    splitLine: { lineStyle: { color: splitColour } },
                    axisLabel: {
                        color: tickColour,
                        formatter: (value) => value >= 1000
                            ? state.formatter.format(Math.round(value / 1000), true, false) + 'k'
                            : state.formatter.format(value, true, false),
                    },
                },
                series: series.map((data, i) => {
                    const [base, hover] = COLOUR_PAIRS[i];
                    const top = i === series.length - 1;
                    return {
                        type: 'bar',
                        stack: 'pay',
                        barMaxWidth: 48,
                        ...(top ? { barMinHeight: 8, itemStyle: { borderRadius: [8, 8, 0, 0] } } : {}),
                        data: data.map((v, idx) => ({
                            value: Number.isNaN(v) ? '-' : v,
                            itemStyle: { color: idx === sel ? hover : base },
                        })),
                    };
                }),
            };
        });
        // One handler covers bar clicks and empty-column clicks: map the click x to the
        // nearest category index, the same nicety the old Chart.js onClick provided.
        function onZrClick(event) {
            const inst = chartRef.value;
            if (!inst || !chartData.value)
                return;
            const point = [event.offsetX, event.offsetY];
            if (!inst.containPixel('grid', point))
                return;
            const idx = inst.convertFromPixel({ xAxisIndex: 0 }, event.offsetX);
            if (idx != null && idx >= 0 && idx < chartData.value.labels.length) {
                handleChartClick(idx);
            }
        }
        const selectedMonthName = computed(() => {
            if (!selectedPayslip.value)
                return '';
            try {
                const dateStr = getPayslipPeriodEnd(selectedPayslip.value.original);
                if (!dateStr)
                    return '';
                const [day, month, year] = dateStr.split('/');
                const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
                return date.toLocaleString('default', { month: 'long', year: 'numeric' });
            }
            catch (e) {
                console.error('Error parsing month name:', e);
                return '';
            }
        });
        function toNumber(value) {
            if (value == null)
                return 0;
            return parseFloat(String(value).replace(/[£,]/g, '')) || 0;
        }
        function findComponent(list, description) {
            if (!Array.isArray(list))
                return { thisPay: 0, ytd: 0 };
            const match = list.find((item) => item && (item.description === description || item.component === description || item.type === description || item.item === description));
            if (!match)
                return { thisPay: 0, ytd: 0 };
            return { thisPay: toNumber(match.thisPay ?? match.amount), ytd: toNumber(match.yearToDate) };
        }
        // Raw `meta` is the unnormalised extraction output — its shape drifts between
        // runs (e.g. `payments` vs `financials`, `type`/`amount` vs `item`/`thisPay`),
        // so this only serves as a fallback behind the normalised DataArray.
        function parseRawMeta(payslip) {
            let meta = {};
            try {
                meta = JSON.parse(payslip.meta);
            }
            catch (e) { /* tolerate missing/invalid meta */ }
            const summary = meta.financialSummary || meta.financial || meta.financials || meta.earnings || meta.payments || {};
            const components = meta.payComponents || meta.components || {};
            const wages = components.wagesAndEarnings || components.earnings || components.wages;
            const employerList = components.employerContributions || meta.employerContributions;
            const grossAmount = toNumber(summary.grossEarnings ?? summary.gross);
            const taxableAmount = toNumber(summary.taxableEarnings ?? summary.taxable);
            const netAmount = toNumber(summary.netPayment ?? summary.net);
            const salary = findComponent(wages, 'Salary');
            const ni = findComponent(components.deductions, 'National Insurance');
            const tax = findComponent(components.taxes, 'PAYE');
            const salarySacrifice = findComponent(components.preTaxDeductions, 'Pension Salary Sacrifice');
            const employerNi = findComponent(employerList, 'National Insurance');
            const employerPension = findComponent(employerList, 'Pension');
            return {
                grossPay: grossAmount,
                grossPayYTD: salary.ytd,
                salarySacrifice: salarySacrifice.thisPay || (grossAmount - taxableAmount),
                salarySacrificeYTD: salarySacrifice.ytd,
                ni: ni.thisPay,
                niYTD: ni.ytd,
                tax: tax.thisPay,
                taxYTD: tax.ytd,
                netPay: netAmount,
                employerNi: employerNi.thisPay,
                employerNiYTD: employerNi.ytd,
                employerPension: employerPension.thisPay,
                employerPensionYTD: employerPension.ytd,
                taxCode: meta?.employee?.taxCode || meta?.taxDetails?.taxCode || meta?.taxCode || '',
            };
        }
        function normaliseTitle(title) {
            return (title || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        }
        // processedMeta.DataArray is the server's normalised, schema-stable view of a
        // payslip (a flat [{Title, Value}] list). It's the same source DocumentPage
        // renders from, which is why the document breakdown is correct for every
        // variant while the raw-meta parse was not. Build a lookup keyed by normalised
        // title so trivial naming drift ("PAYE" vs "PAYE This Pay") still matches.
        function buildFieldMap(payslip) {
            const map = new Map();
            try {
                const arr = JSON.parse(payslip.processedMeta)?.DataArray;
                if (Array.isArray(arr)) {
                    for (const item of arr) {
                        if (item?.Title != null && item.Value != null) {
                            map.set(normaliseTitle(item.Title), String(item.Value));
                        }
                    }
                }
            }
            catch (e) { /* tolerate missing/invalid processedMeta */ }
            return map;
        }
        function parsePayslipMeta(payslip) {
            const raw = parseRawMeta(payslip);
            const fields = buildFieldMap(payslip);
            // Prefer the normalised DataArray; fall back to the raw-meta parse only when
            // a field is genuinely absent (e.g. an older variant that omits a YTD line).
            const pick = (candidates, fallback) => {
                for (const c of candidates) {
                    const v = fields.get(normaliseTitle(c));
                    if (v != null && v.trim() !== '')
                        return toNumber(v);
                }
                return fallback;
            };
            return {
                grossPay: pick(['Gross Earnings', 'Gross Pay', 'Gross'], raw.grossPay),
                grossPayYTD: pick(['Salary Year To Date', 'Gross Year To Date'], raw.grossPayYTD),
                salarySacrifice: pick(['Pension Salary Sacrifice This Pay', 'Pension Salary Sacrifice', 'Salary Sacrifice'], raw.salarySacrifice),
                salarySacrificeYTD: pick(['Pension Salary Sacrifice Year To Date'], raw.salarySacrificeYTD),
                ni: pick(['National Insurance This Pay', 'National Insurance'], raw.ni),
                niYTD: pick(['National Insurance Year To Date'], raw.niYTD),
                tax: pick(['PAYE This Pay', 'PAYE', 'Tax This Pay', 'Tax'], raw.tax),
                taxYTD: pick(['PAYE Year To Date', 'Tax Year To Date'], raw.taxYTD),
                netPay: pick(['Net Payment', 'Net Pay'], raw.netPay),
                employerNi: pick(['Employer NI Contribution This Pay', 'Employer NI Contribution', 'Employer National Insurance'], raw.employerNi),
                employerNiYTD: pick(['Employer NI Contribution Year To Date', 'Employer National Insurance Year To Date'], raw.employerNiYTD),
                employerPension: pick(['Employer Pension Contribution This Pay', 'Employer Pension Contribution', 'Employer Pension'], raw.employerPension),
                employerPensionYTD: pick(['Employer Pension Contribution Year To Date', 'Employer Pension Year To Date'], raw.employerPensionYTD),
                taxCode: fields.get(normaliseTitle('Tax Code')) || raw.taxCode || '',
                original: payslip
            };
        }
        function getPayslipPeriodEnd(payslip) {
            try {
                const meta = JSON.parse(payslip.meta);
                // Schema variants: payPeriod can be an object {periodEnd|end} or a string
                // code (e.g. "M1"), in which case periodEnd lives at the top level.
                if (meta?.payPeriod && typeof meta.payPeriod === 'object') {
                    const end = meta.payPeriod.periodEnd || meta.payPeriod.end;
                    if (end)
                        return end;
                }
                else if (meta?.periodEnd) {
                    return meta.periodEnd;
                }
            }
            catch (e) { /* fall through to normalised DataArray */ }
            const fields = buildFieldMap(payslip);
            return fields.get(normaliseTitle('Pay Period End'))
                || fields.get(normaliseTitle('Period Ending'))
                || fields.get(normaliseTitle('Period End'))
                || null;
        }
        function isPayslip(doc) {
            const t = (doc?.documentType || '').toLowerCase();
            const n = (doc?.name || '').toLowerCase();
            if (isHmrcDoc(doc))
                return false;
            return t === 'payslip' || t === 'payroll' || n.includes('payslip');
        }
        function hmrcKind(doc) {
            const t = (doc?.documentType || '').toLowerCase();
            const n = (doc?.name || '').toLowerCase();
            if (t === 'p60' || n.includes('p60'))
                return 'P60';
            if (t === 'p11d' || n.includes('p11d'))
                return 'P11D';
            if (t === 'p45' || n.includes('p45'))
                return 'P45';
            return null;
        }
        function isHmrcDoc(doc) {
            return hmrcKind(doc) !== null;
        }
        function parseHmrcForm(doc) {
            const kind = hmrcKind(doc);
            let meta = {};
            try {
                meta = doc.meta ? JSON.parse(doc.meta) : {};
            }
            catch (e) { /* keep empty meta on parse failure */ }
            let year = meta?.taxYear || '';
            if (typeof year === 'string') {
                const m = year.match(/(\d{4})\s*[-–/]\s*(\d{4})/) || year.match(/(\d{4})/);
                if (m)
                    year = m[0];
            }
            if (!year && doc.renewalDate) {
                year = new Date(doc.renewalDate).getFullYear().toString();
            }
            let headline = '';
            if (kind === 'P60') {
                const total = meta?.payAndIncomeTaxDetails?.totalForYear?.pay;
                const tax = meta?.payAndIncomeTaxDetails?.totalForYear?.taxDeducted;
                if (total != null)
                    headline = `Pay ${state.formatter.format(toNumber(total))}` + (tax != null ? ` · Tax ${state.formatter.format(toNumber(tax))}` : '');
            }
            else if (kind === 'P11D') {
                const cash = meta?.benefits?.privateMedicalTreatment?.cashEquivalent;
                if (cash != null)
                    headline = `Benefits ${state.formatter.format(toNumber(cash))}`;
            }
            else if (kind === 'P45') {
                const leaving = meta?.leavingDate || meta?.dateOfLeaving;
                if (leaving)
                    headline = `Leaving date ${leaving}`;
            }
            if (!headline)
                headline = doc.documentSubject || '';
            return {
                id: doc.id,
                kind,
                year: String(year || 'Unknown year'),
                company: properCase(doc.company || doc.documentSubject || ''),
                fileName: doc.documentName || doc.name || kind,
                dateString: doc.createDateTimeString || '',
                subject: doc.documentSubject || '',
                headline,
                renewalDate: doc.renewalDate || null,
            };
        }
        function properCase(str) {
            if (!str)
                return '';
            return str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
        }
        const hmrcByYear = computed(() => {
            const groups = new Map();
            for (const form of hmrcForms.value) {
                if (!groups.has(form.year))
                    groups.set(form.year, []);
                groups.get(form.year).push(form);
            }
            return [...groups.entries()]
                .map(([year, forms]) => ({ year, forms }))
                .sort((a, b) => b.year.localeCompare(a.year));
        });
        function viewPayslip() {
            if (selectedPayslip.value && selectedPayslip.value.original && selectedPayslip.value.original.id) {
                router.push(`/documents/${selectedPayslip.value.original.id}`);
            }
        }
        function loadPayslips() {
            getDocuments(() => {
                const docs = state.documents || [];
                payslips.value = docs.filter(isPayslip).filter((doc) => doc.meta);
                hmrcForms.value = docs.filter(isHmrcDoc).filter((doc) => doc.meta).map(parseHmrcForm);
                prepareChartData();
            });
        }
        function prepareChartData() {
            const labels = [];
            const netData = [];
            const taxData = [];
            const salarySacrificeData = [];
            const nationalInsuranceData = [];
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth();
            let latestPayslipData = null;
            let latestPayslipIndex = -1;
            for (let i = 5; i >= 0; i--) {
                const targetDate = new Date(currentYear, currentMonth - i, 1);
                const monthName = targetDate.toLocaleString('default', { month: 'short' });
                const targetYear = targetDate.getFullYear();
                const targetMonth = targetDate.getMonth() + 1;
                labels.push(monthName);
                let foundPayslip = null;
                for (const payslip of payslips.value) {
                    if (!payslip.meta)
                        continue;
                    try {
                        const periodEndingStr = getPayslipPeriodEnd(payslip);
                        if (!periodEndingStr)
                            continue;
                        const parts = periodEndingStr.split('/');
                        const payslipMonth = parseInt(parts[1], 10);
                        const payslipYear = parseInt(parts[2], 10);
                        if (payslipMonth === targetMonth && payslipYear === targetYear) {
                            foundPayslip = payslip;
                            break;
                        }
                    }
                    catch (e) {
                        console.error('Error parsing payslip meta:', e);
                    }
                }
                if (foundPayslip) {
                    try {
                        const parsed = parsePayslipMeta(foundPayslip);
                        netData.push(parsed.netPay);
                        taxData.push(parsed.tax);
                        salarySacrificeData.push(parsed.salarySacrifice);
                        nationalInsuranceData.push(parsed.ni);
                        latestPayslipData = parsed;
                        latestPayslipIndex = 5 - i;
                    }
                    catch (e) {
                        console.error('Error processing payslip data:', e);
                        netData.push(0);
                        taxData.push(0);
                        salarySacrificeData.push(0);
                        nationalInsuranceData.push(0);
                    }
                }
                else {
                    netData.push(0);
                    taxData.push(0);
                    salarySacrificeData.push(0);
                    nationalInsuranceData.push(NaN);
                }
            }
            if (latestPayslipData) {
                selectedPayslip.value = latestPayslipData;
                selectedIndex.value = latestPayslipIndex;
            }
            chartData.value = {
                labels,
                net: netData,
                tax: taxData,
                salarySacrifice: salarySacrificeData,
                ni: nationalInsuranceData,
            };
        }
        function handleChartClick(index) {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth();
            const targetDate = new Date(currentYear, currentMonth - (5 - index), 1);
            const targetYear = targetDate.getFullYear();
            const targetMonth = targetDate.getMonth() + 1;
            let foundPayslip = null;
            for (const payslip of payslips.value) {
                if (!payslip.meta)
                    continue;
                try {
                    const periodEndingStr = getPayslipPeriodEnd(payslip);
                    if (!periodEndingStr)
                        continue;
                    const parts = periodEndingStr.split('/');
                    const payslipMonth = parseInt(parts[1], 10);
                    const payslipYear = parseInt(parts[2], 10);
                    if (payslipMonth === targetMonth && payslipYear === targetYear) {
                        foundPayslip = payslip;
                        break;
                    }
                }
                catch (e) {
                    console.error('Error parsing payslip meta:', e);
                }
            }
            if (foundPayslip) {
                try {
                    selectedPayslip.value = parsePayslipMeta(foundPayslip);
                    selectedIndex.value = index;
                }
                catch (e) {
                    console.error('Error processing clicked payslip:', e);
                }
            }
        }
        onMounted(() => {
            getCustomer(() => { });
            loadPayslips();
            nextTick(updateTabActivePosition);
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Payslips & Tax" }),
                _createElementVNode("div", {
                    class: _normalizeClass(["payslips-page", { dark: _unref(isDarkMode) }])
                }, [
                    _createVNode(AiChatBanner, {
                        prompts: aiPrompts.value,
                        dynamicSuggestions: true,
                        context: aiContext.value
                    }, null, 8, ["prompts", "context"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: "tab-active-bg",
                            style: _normalizeStyle({ left: tabActiveLeft.value + 'px', width: tabActiveWidth.value + 'px' })
                        }, null, 4),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab, index) => {
                            return _createElementVNode("button", {
                                key: tab.key,
                                ref_for: true,
                                ref: el => setTabRef(index, el),
                                class: _normalizeClass(["tab", { 'tab--selected': activeTab.value === tab.key }]),
                                onClick: ($event) => (activeTab.value = tab.key)
                            }, _toDisplayString(tab.label), 11, _hoisted_2);
                        }), 64))
                    ]),
                    (activeTab.value === 'pay')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (chartData.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createVNode(_unref(VChart), {
                                        ref_key: "chartRef",
                                        ref: chartRef,
                                        option: chartOption.value,
                                        style: { height: '100%', width: '100%' },
                                        autoresize: "",
                                        "onZr:click": onZrClick
                                    }, null, 8, ["option"])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(_component_v_skeleton_loader, {
                                        type: "card",
                                        loading: true
                                    })
                                ])),
                            (selectedPayslip.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("h2", null, _toDisplayString(selectedMonthName.value), 1),
                                        (selectedPayslip.value.taxCode)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Tax code: " + _toDisplayString(selectedPayslip.value.taxCode), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", {
                                                class: "breakdown-item gross-pay",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (toggleRow('gross')))
                                            }, [
                                                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "Gross Pay", -1)),
                                                _createElementVNode("span", _hoisted_10, [
                                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.grossPay)), 1),
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["chevron", { expanded: expandedRows.value.gross }])
                                                    }, "▼", 2)
                                                ])
                                            ]),
                                            _createVNode(_Transition, { name: "ytd" }, {
                                                default: _withCtx(() => [
                                                    (expandedRows.value.gross)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ytd-label" }, "Year to date", -1)),
                                                            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.grossPayYTD)), 1)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("div", {
                                                class: "breakdown-item deductions-summary",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (toggleRow('deductions')))
                                            }, [
                                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Deductions & contributions", -1)),
                                                _createElementVNode("span", _hoisted_15, [
                                                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(state).formatter.format(deductionsTotal.value)), 1),
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["chevron", { expanded: expandedRows.value.deductions }])
                                                    }, "▼", 2)
                                                ])
                                            ]),
                                            _createVNode(_Transition, { name: "deductions" }, {
                                                default: _withCtx(() => [
                                                    (expandedRows.value.deductions)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                            _createElementVNode("div", _hoisted_18, [
                                                                _createElementVNode("div", {
                                                                    class: "breakdown-item salary-sacrifice",
                                                                    onClick: _cache[2] || (_cache[2] = ($event) => (toggleRow('salarySacrifice')))
                                                                }, [
                                                                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "Salary Sacrifice", -1)),
                                                                    _createElementVNode("span", _hoisted_19, [
                                                                        _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.salarySacrifice)), 1),
                                                                        _createElementVNode("span", {
                                                                            class: _normalizeClass(["chevron", { expanded: expandedRows.value.salarySacrifice }])
                                                                        }, "▼", 2)
                                                                    ])
                                                                ]),
                                                                _createVNode(_Transition, { name: "ytd" }, {
                                                                    default: _withCtx(() => [
                                                                        (expandedRows.value.salarySacrifice)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ytd-label" }, "Year to date", -1)),
                                                                                _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.salarySacrificeYTD)), 1)
                                                                            ]))
                                                                            : _createCommentVNode("", true)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _createElementVNode("div", _hoisted_23, [
                                                                _createElementVNode("div", {
                                                                    class: "breakdown-item national-insurance",
                                                                    onClick: _cache[3] || (_cache[3] = ($event) => (toggleRow('ni')))
                                                                }, [
                                                                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "National Insurance", -1)),
                                                                    _createElementVNode("span", _hoisted_24, [
                                                                        _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.ni)), 1),
                                                                        _createElementVNode("span", {
                                                                            class: _normalizeClass(["chevron", { expanded: expandedRows.value.ni }])
                                                                        }, "▼", 2)
                                                                    ])
                                                                ]),
                                                                _createVNode(_Transition, { name: "ytd" }, {
                                                                    default: _withCtx(() => [
                                                                        (expandedRows.value.ni)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ytd-label" }, "Year to date", -1)),
                                                                                _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.niYTD)), 1)
                                                                            ]))
                                                                            : _createCommentVNode("", true)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _createElementVNode("div", _hoisted_28, [
                                                                _createElementVNode("div", {
                                                                    class: "breakdown-item tax",
                                                                    onClick: _cache[4] || (_cache[4] = ($event) => (toggleRow('tax')))
                                                                }, [
                                                                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "Tax", -1)),
                                                                    _createElementVNode("span", _hoisted_29, [
                                                                        _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.tax)), 1),
                                                                        _createElementVNode("span", {
                                                                            class: _normalizeClass(["chevron", { expanded: expandedRows.value.tax }])
                                                                        }, "▼", 2)
                                                                    ])
                                                                ]),
                                                                _createVNode(_Transition, { name: "ytd" }, {
                                                                    default: _withCtx(() => [
                                                                        (expandedRows.value.tax)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ytd-label" }, "Year to date", -1)),
                                                                                _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.taxYTD)), 1)
                                                                            ]))
                                                                            : _createCommentVNode("", true)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            (selectedPayslip.value.employerNi)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                                    _createElementVNode("div", {
                                                                        class: "breakdown-item employer-ni",
                                                                        onClick: _cache[5] || (_cache[5] = ($event) => (toggleRow('employerNi')))
                                                                    }, [
                                                                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "Employer NI", -1)),
                                                                        _createElementVNode("span", _hoisted_34, [
                                                                            _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.employerNi)), 1),
                                                                            _createElementVNode("span", {
                                                                                class: _normalizeClass(["chevron", { expanded: expandedRows.value.employerNi }])
                                                                            }, "▼", 2)
                                                                        ])
                                                                    ]),
                                                                    _createVNode(_Transition, { name: "ytd" }, {
                                                                        default: _withCtx(() => [
                                                                            (expandedRows.value.employerNi)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                                                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ytd-label" }, "Year to date", -1)),
                                                                                    _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.employerNiYTD)), 1)
                                                                                ]))
                                                                                : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (selectedPayslip.value.employerPension)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                                    _createElementVNode("div", {
                                                                        class: "breakdown-item employer-pension",
                                                                        onClick: _cache[6] || (_cache[6] = ($event) => (toggleRow('employerPension')))
                                                                    }, [
                                                                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "Employer Pension", -1)),
                                                                        _createElementVNode("span", _hoisted_39, [
                                                                            _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.employerPension)), 1),
                                                                            _createElementVNode("span", {
                                                                                class: _normalizeClass(["chevron", { expanded: expandedRows.value.employerPension }])
                                                                            }, "▼", 2)
                                                                        ])
                                                                    ]),
                                                                    _createVNode(_Transition, { name: "ytd" }, {
                                                                        default: _withCtx(() => [
                                                                            (expandedRows.value.employerPension)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                                                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "ytd-label" }, "Year to date", -1)),
                                                                                    _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.employerPensionYTD)), 1)
                                                                                ]))
                                                                                : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("div", _hoisted_44, [
                                                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "Net Pay", -1)),
                                                _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(state).formatter.format(selectedPayslip.value.netPay)), 1)
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (selectedPayslip.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createVNode(MGButton, {
                                        text: "View Payslip",
                                        fullWidth: true,
                                        arrow: true,
                                        onClick: viewPayslip
                                    })
                                ]))
                                : _createCommentVNode("", true)
                        ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (hmrcByYear.value.length === 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "empty-state" }, [
                                        _createElementVNode("div", { class: "empty-title" }, "No tax forms yet"),
                                        _createElementVNode("div", { class: "empty-body" }, " Send us a photo or PDF of your P60, P11D or P45 on WhatsApp — we'll file it here automatically, grouped by tax year. ")
                                    ], -1)),
                                    _createVNode(WhatsAppPromoCard, {
                                        class: "whatsapp-promo",
                                        ref_key: "whatsAppPromoCard",
                                        ref: whatsAppPromoCard,
                                        showImage: true,
                                        closable: false,
                                        title: "Send a tax form",
                                        subtitle: "Send us your P60, P11D or P45 on WhatsApp and we'll save it here.",
                                        onAction: _unref(handleWhatsAppAction)
                                    }, null, 8, ["onAction"])
                                ], 64))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hmrcByYear.value, (group) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: group.year,
                                    class: "tax-year-section"
                                }, [
                                    _createElementVNode("h2", _hoisted_47, _toDisplayString(group.year), 1),
                                    _createElementVNode("div", _hoisted_48, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.forms, (form) => {
                                            return (_openBlock(), _createBlock(DocumentListItem, {
                                                key: form.id,
                                                company: form.company,
                                                fileName: form.fileName,
                                                date: form.dateString,
                                                documentType: form.subject,
                                                onClick: ($event) => (_unref(router).push(`/documents/${form.id}`))
                                            }, null, 8, ["company", "fileName", "date", "documentType", "onClick"]));
                                        }), 128))
                                    ])
                                ]));
                            }), 128))
                        ], 64))
                ], 2),
                _createVNode(WhatsAppEnableDrawer, {
                    ref_key: "whatsAppEnableDrawer",
                    ref: whatsAppEnableDrawer,
                    phoneNumber: _unref(state).customer?.person?.mobilePhone || '',
                    onEnable: _unref(handleEnableWhatsApp),
                    onDone: _unref(handleWhatsAppEnableDone),
                    onClosed: _unref(handleWhatsAppDrawerClosed)
                }, null, 8, ["phoneNumber", "onEnable", "onDone", "onClosed"])
            ], 64));
        };
    }
});
